<template>
    <div class="major-detail-box">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/major' }">查专业</el-breadcrumb-item>
            <el-breadcrumb-item>专业详情</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="major-detail-bg">
            <ContentLoader v-if="!majorInfor.special_name" primaryColor="rgba(255,255,255,0.1)" secondaryColor="rgba(255,255,255,0.05)" :base-url="$route.fullPath" height="110" width="1000" viewBox="0 0 1000 110">
                <rect x="0" y="0" width="50" height="32" />
                <rect x="0" y="52" width="140" height="23" />
            </ContentLoader>
            <el-row v-else>
                <el-col :span="18">
                    <div class="zytb-school-name">{{majorInfor.special_name}}</div>
                    <div class="zytb-school-tag">
                        <span>限修年限:{{majorInfor.limit_year}}</span>
                        <span>文科理科填报比例:{{majorInfor.special_type_rate != ':' && majorInfor.special_type_rate ? percentData[0].value + '%/'+ percentData[1].value + '%' : '--'}}</span>
                        <span>男女比例:{{majorInfor.boy_rate!= 0 && majorInfor.girl_rate!=0 ? majorInfor.boy_rate + '%/' + majorInfor.girl_rate + "%": '--'}}</span>
                    </div>
                </el-col>
                <el-col :span="6">
					<el-button class="compare-view" v-if="fav_value < 0.00" v-click-with-auth-login @click="favDetail">
						<img src="../../assets/images/fav_icon1.png" alt="设为心仪" class="fav-img1">
						设为心仪
					</el-button>
					<el-button v-else class="compare-view-diff" @click="favDetail">
						<el-rate
							v-model="fav_value"
							disabled
							:max="1"
							:show-score="false"
							disabled-void-color="#ffcab3"
							score-template="{fav_value}">
						</el-rate>
						{{ fav_value === 0.99 ? '心仪专业': '心仪详情' }}
					</el-button>
				</el-col>
            </el-row>
        </el-row>
        <el-tabs v-model="activeName" @tab-click="handleClick" class="school-detail-nav" :class="scrollTag?'fixed-top':''">
            <el-tab-pane label="专业概况" name="first">
                <el-row>
                    <el-col :span="16" style="padding-right: 16px;width:67.5%">
                        <div class="school-detail-common">
                            <h3>专业简介</h3>
                            <div class="major-detail-js major-detail-blue">是什么</div>
                            <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="30" width="1000" viewBox="0 0 1000 50"  v-if="!searchSchoolStatus1">
                                <rect x="0" y="10" width="1000" height="20" />
                            </ContentLoader>
                            <div v-else>
                                <p v-if="majorInfor.special_is_what">{{majorInfor.special_is_what}}</p>
                                <p v-else>暂无数据</p>
                            </div>
                            <div class="major-detail-js major-detail-green">学什么</div>
                            <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="30" width="1000" viewBox="0 0 1000 50"  v-if="!searchSchoolStatus1">
                                <rect x="0" y="10" width="1000" height="20" />
                            </ContentLoader>
                            <div v-else>
                                <p v-if="majorInfor.special_learn_what">{{majorInfor.special_learn_what}}</p>
                                <p v-else>暂无数据</p>
                            </div>
                            <div class="major-detail-js major-detail-hs">做什么</div>
                            <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="30" width="1000" viewBox="0 0 1000 50"  v-if="!searchSchoolStatus1">
                                <rect x="0" y="10" width="1000" height="20" />
                            </ContentLoader>
                            <div v-else>
                                <p v-if="majorInfor.special_do_what">{{majorInfor.special_do_what}}</p>
                                <p v-else>暂无数据</p>
                            </div>
                        </div>
                        <div class="school-detail-common">
                            <h3>详解</h3>
                            <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="70" width="1000" viewBox="0 0 1000 50"  v-if="!searchSchoolStatus1">
                                <rect x="0" y="10" width="1000" height="50" />
                            </ContentLoader>
                            <div v-else>
                                <div class="no-data-box" v-if="!majorInfor.special_content">
                                    <img src="../../assets/images/null.png" alt="没有数据">
                                    <p>暂无数据</p>
                                </div>
                                <el-row class="school-detail-content" v-else>
                                    <div class="special-content-p special-content-p-diff" :class="{'special-content-p-more':showAllContent} " v-html="majorInfor.special_content">
                                    </div>
                                    <div class="choice-box" @click="showAllhandler" v-if="!showAllContent && majorInfor.special_content.length > 100">查看全部<i class="el-icon-arrow-down"></i></div>
                                    <div class="choice-box" @click="showAllhandler" v-else-if="showAllContent && majorInfor.special_content.length > 100">收起<i class="el-icon-arrow-up"></i></div>
                                </el-row>
                            </div>
                        </div>
                        <div class="school-detail-common">
                            <h3>就业率(近三年)</h3>
                            <div class="no-data-box" v-if="majorInfor.special_jobrate == ''">
                                <img src="../../assets/images/null.png" alt="没有数据">
                                <p>暂无数据</p>
                            </div>
                            <div class="school-detail-jyl" v-else>
                                <el-timeline>
                                    <el-timeline-item :timestamp="item.year" placement="top" v-for="(item,index) in majorInfor.special_jobrate" :key="index">
                                    <el-row :class="'el-progress-' + index">
                                        <el-progress :percentage="item.rate|percent" :show-text="false"></el-progress>
                                        <span>{{item.rate}}</span>
                                    </el-row>
                                    </el-timeline-item>
                                </el-timeline>
                            </div>
                        </div>
                        <div class="school-detail-common">
                            <h3>考研方向</h3>
                            <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="30" width="1000" viewBox="0 0 1000 50"  v-if="!searchSchoolStatus1">
                                <rect x="0" y="10" width="1000" height="20" />
                            </ContentLoader>
                            <div v-else>
                                <div class="no-data-box" v-if="!majorInfor.special_direction">
                                    <img src="../../assets/images/null.png" alt="没有数据">
                                    <p>暂无数据</p>
                                </div>
                                <p v-else class="special-content-p">{{majorInfor.special_direction}}</p>
                            </div>
                        </div>
                        <div class="school-detail-common">
                            <h3>开设课程</h3>
                            <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="30" width="1000" viewBox="0 0 1000 50"  v-if="!searchSchoolStatus1">
                                <rect x="0" y="10" width="1000" height="20" />
                            </ContentLoader>
                            <div v-else>
                                <div class="no-data-box" v-if="!majorInfor.special_course">
                                    <img src="../../assets/images/null.png" alt="没有数据">
                                    <p>暂无数据</p>
                                </div>
                                <p v-else class="special-content-p">{{majorInfor.special_course}}</p>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="6" style="width:32.5%">
                        <div class="school-detail-common">
                            <h3>选考学科建议</h3>
                            <div class="no-data-box" v-if="!majorInfor.special_sel_adv">
                                <img src="../../assets/images/null.png" alt="没有数据">
                                <p>暂无数据</p>
                            </div>
                            <div class="school-detail-jy" v-else>{{majorInfor.special_sel_adv}}</div>
                        </div>
                        <el-row class="major-detail-sex">
                            <el-col :span="24">
                                <div class="school-detail-common">
                                    <h3>男女比例</h3>
                                    <!-- <div class="no-data-box" v-if="majorInfor.boy_rate == '0' && majorInfor.girl_rate == '0'">
                                        <img src="../../assets/images/null.png" alt="没有数据">
                                        <p>暂无数据</p>
                                    </div>
                                    <el-row v-else> -->
                                    <el-row>
                                        <el-col :span="5" style="text-align:center;">
                                            <img src="../../assets/images/boy.png" alt="男生">
                                            <div>男生</div>
                                        </el-col>
                                        <el-col :span="14">
                                            <div class="major-detail-xb">
                                                <span class="major-detail-boy">{{majorInfor.boy_rate}}%</span>
                                                <span class="major-detail-girl">{{majorInfor.girl_rate}}%</span>
                                            </div>
                                            <div class="major-detail-bl"></div>
                                            <div class="major-detail-bl-boy" :style="{width:majorInfor.boy_rate *1.64 + 'px'}"></div>
                                        </el-col>
                                        <el-col :span="5" style="text-align:center;">
                                            <img src="../../assets/images/girl.png" alt="女生">
                                            <div>女生</div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>
                            <el-col :span="24">
                                <div class="school-detail-common school-detail-wl">
                                    <h3>文理比例</h3>
                                    <div class="no-data-box" v-if="majorInfor.special_type_rate == ':' || !majorInfor.special_type_rate">
                                        <img src="../../assets/images/null.png" alt="没有数据">
                                        <p>暂无数据</p>
                                    </div>
                                    <el-row v-else>
                                        <el-col :span="24">
                                            <div ref="chart" style="width:300px;height:300px;top: -90px;left: 18px;position:absolute"></div>
                                        </el-col>
                                        <el-col :span="24" class="school-detail-wl-rate">
                                            <div>文科<span style="color: #3272ff;float:right;">{{percentData[0].value}}%</span></div>
                                            <div>理科<span style="color: #fe9f0a;float:right;">{{percentData[1].value}}%</span></div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>
                        </el-row>
                         <div class="school-detail-common">
                            <h3>社会名人</h3>
                            <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="30" width="1000" viewBox="0 0 1000 50"  v-if="!searchSchoolStatus1">
                                <rect x="0" y="10" width="1000" height="20" />
                            </ContentLoader>
                            <div v-else>
                                <div class="no-data-box" v-if="!majorInfor.special_celebrity">
                                    <img src="../../assets/images/null.png" alt="没有数据">
                                    <p>暂无数据</p>
                                </div>
                                <p v-else class="special-content-p">{{majorInfor.special_celebrity}}</p>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane label="相关就业" name="second">
                <el-row>
                    <el-col :span="16" style="padding-right: 16px;width:67.5%">
                        <div class="school-detail-common major-detail-common">
                            <h3>就业行业分布</h3>
                            <div class="no-data-box" v-if="majorInfor.special_job_industry.length == 0">
                                <img src="../../assets/images/null.png" alt="没有数据">
                                <p>暂无数据</p>
                            </div>
                            <div v-else class="school-detail-jyl school-detail-jyfb" v-for="(item,index) in majorInfor.special_job_industry" :key="index">
                                <el-row class="el-progress-blue">
                                    <span class="school-detail-qt">{{item.name}}</span>
                                    <el-progress :percentage="item.rate|numberPer" :show-text="false"></el-progress>
                                    <span>{{item.rate}}%</span>
                                </el-row>
                            </div>
                        </div>
                        <div class="school-detail-common school-detail-gwfb" :class="areaDataX.length != 0?'school-detail-gwfb-diff1':''">
                            <h3>就业地区分布</h3>
                            <div class="no-data-box" v-if="areaDataX.length == 0">
                                <img src="../../assets/images/null.png" alt="没有数据">
                                <p>暂无数据</p>
                            </div>
                            <div ref="chart2" v-else style="width:880px;height:400px;top: -54px;left: -60px;"></div>
                        </div>
                    </el-col>
                    <el-col :span="6" style="width:32.5%">
                        <div class="school-detail-common school-detail-gwfb">
                            <h3>就业岗位分布</h3>
                            <div class="no-data-box" v-if="jobData.length == 0">
                                <img src="../../assets/images/null.png" alt="没有数据">
                                <p>暂无数据</p>
                            </div>
                            <el-row v-else>
                                <el-col :span="24">
                                    <div ref="chart1" style="width:350px;height:350px;top: -70px;left: -10px;"></div>
                                </el-col>
                                <el-col :span="24" style="margin-top: -115px">
                                    <div class="major-detail-gwfb" v-for="(item,index) in majorInfor.special_job_post" :key="index">
                                        <div class="major-detail-gwfb-qt" :class="'major-detail-gwfb-' + index">{{item.detail_pos}}{{item.rate}}%</div>
                                        <div>具体职位：</div>
                                        <p>{{item.detail_job}}</p>
                                        <div>所在行业：</div>
                                        <p>{{item.name}}</p>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane label="开设院校" name="third">
                <div class="school-detail-common">
                    <h3>开设院校</h3>
                    <div v-if="!searchSchoolStatus1">
                        <ContentLoader primaryColor="#f0f2f5" secondaryColor="#EFEFEF" :base-url="$route.fullPath" height="110" width="1100" viewBox="0 0 1000 110" v-for="item in 20" :key="item">
                            <rect x="80" y="30" width="70" height="20" />
                            <rect x="80" y="60" width="140" height="23" />
                            <rect x="1000" y="50" width="110" height="30" />
                            <circle cx="35" cy="60" r="32" />
                            <rect x="80" y="109" width="725" height="1" />
                        </ContentLoader>
                    </div>
                    <div v-else>
                        <div class="no-data-box" v-if="schoolList.length == 0 && searchSchoolStatus1">
                            <img src="../../assets/images/null.png" alt="没有数据">
                            <p>暂无数据</p>
                        </div>
                        <el-row class="collapse-box" v-else>
                            <div class="collapse-list" v-for="(item,index) in schoolList" :key="index">
                                <el-col :span="3">
                                    <el-image :src="'https://gaokao.zmpajx.com/pic/' + item.scl_id + '.jpg'" alt="大学logo">
                                        <div slot="error" class="image-slot">
                                            <img src="../../assets/images/scl_default.png" alt="大学logo">
                                        </div>
                                    </el-image>
                                </el-col>
                                <el-col :span="17">
                                <div class="zytb-school-name">
                                    {{item.scl_name}}<img src="../../assets/images/wz.png" alt="位置">
                                    <span>{{item.province_name.indexOf('北京') != -1 || item.province_name.indexOf('天津') != -1 || item.province_name.indexOf('上海') != -1 || item.province_name.indexOf('重庆') != -1 ? '' : item.province_name}}{{item.city_name}}</span>
                                </div>
                                <div class="zytb-school-tag">
                                    <span v-if="item.school_nature_type">{{item.school_nature_type}}</span>
                                    <span v-if="item.school_type">{{item.school_type}}</span>
                                    <span v-if="item.school_nature">{{item.school_nature}}</span>
                                    <span v-if="item.f211 == '1'" style="background:#fff4e3;color:#fe9f0a;">211</span>
                                    <span v-if="item.f985 == '1'" style="background:#fff0e9;color:$common-color;">985</span>
                                    <span v-if="item.dual_class != '38003' && item.dual_class" style="background:#e4f4e9;color:#01c13b;">双一流</span>
                                    <span v-if="item.is_provincial == '1'" style="background: #FDEFFF;color: #D250E0">省重点</span>
                                    <span v-if="item.is_doublehigh == '77'" style="background: #ECEDFF;color: #5964FF">双高计划</span>
                                </div>
                                </el-col>
                                <el-col :span="4">
                                    <el-button @click="schoolDetailHandler(item.scl_id)">查看学校详情</el-button>
                                </el-col>
                                <div class="con-clear"></div>
                                <el-row class="con-line"></el-row>
                            </div>
                            <el-pagination
                                background
                                layout="prev, pager, next, jumper"
                                :total="totalData" :page-size="20" @current-change="getRelateSchoolType" :current-page.sync="currentPage" v-if="totalData > 0">
                            </el-pagination>
                        </el-row>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <FavDetail v-if="isFav" :favList="fav_data" :favInfo="fav_info" @update="updateFav"></FavDetail>
    </div>
</template>

<script>
import echarts from 'echarts'
import { getSearchDic } from "@/api/zhiyuan"
import { getSpecialDetail, getRelateSchool } from '@/api/major'
import { ContentLoader } from 'vue-content-loader'
import { decrypt } from '@/utils/auth'
import { mapState } from 'vuex'
import { addFav, delFav } from '@/api/user'
import FavDetail from '@/components/FavDetail'
export default {
    components: {
        ContentLoader,
		FavDetail
    },
    data() {
        return {
            activeName: 'first',
            showAllContent: false,
            currentPage:1,
            special_id: '',
            majorInfor: {
                special_job_industry: []
            },
            percentData: [
                {value: 0, name: '文科'},
                {value: 0, name: '理科'},
            ],
            jobData: [],
            areaDataX: [],
            areaDataY: [],
            schoolList: [],
            totalData: 0,
            searchSchoolStatus1: false,
            scrollTag: false,
            scrollTop: 0,
            fav_value: 0,
			fav_data: [],
			fav_info: {},
            type_edu: {},
        }
    },
    filters: {
        percent(rage) {
            let per = rage.split("%");
            return Number(per[0]);
        },
        numberPer(rage) {
            return Number(rage);
        },
    },
    computed: {
        ...mapState({
            requestCount: state => state.user.requestCount,
            isFav: state => state.user.isFav
        })
    },
    watch: {
        requestCount (newVal) {
            if(newVal > 0) {
                this.searchSchoolStatus1 = false;
            } else {
                this.searchSchoolStatus1 = true;
            }
        },
    },
    created() {
        this.$store.commit('user/ADDCOUNT', 0);
        this.special_id = this.$route.query.special_id;
        this.getSearchDicHandler();
        setTimeout(()=>{
            this.getSpecialDetailHandler();
        }, 200)
    },
    mounted() {
		window.addEventListener('scroll', this.getScroll, true);
	},
    destroyed() {
        window.removeEventListener('scroll', this.getScroll, true)
    },
    methods: {
        getSearchDicHandler() {
            try {
                getSearchDic().then(res => {
                    if (res.status != 200 || !res) {
                        return
                    }
                    res.data.edu_type.map( item => {
                        this.type_edu[item.dic_code] = item.dic_value
                    })
                }).catch(error => {
                    console.log(error);
                })
            } catch (error) { console.log(error) }
        },
        getScroll() {
            let top = document.getElementById('app').scrollTop
            this.scrollTop = top;
            if (top > 420) {
                this.scrollTag = true;
            } else {
                this.scrollTag = false;
            }
        },
        showAllhandler() {
			this.showAllContent = !this.showAllContent;
		},
        handleClick() {
            if(this.scrollTop > 420) {
                document.getElementById('app').scrollTo(0, 460);
            } else {
                this.scrollTag = false;
            }
            if(this.activeName == 'third') {
                this.currentPage = 1;
                this.getRelateSchoolhandler('1');
            }
        },
        getRelateSchoolType(page) {
            if(this.special_id) {
                this.getRelateSchoolhandler(page);
            } else {
                this.getRelateSchoolOtherhandler(page);
            }
        },
        myEcharts() {
            const myChart = echarts.init(this.$refs.chart);
            const option = {
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        type: 'pie',
                        radius: '48.5%',
                        data: this.percentData,
                        color:['#3272ff', '#fe9f0a'],
                    }
                ]
            };
            myChart.setOption(option);
        },
        myEcharts1() {
            const myChart = echarts.init(this.$refs.chart1);
            const option = {
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['35%', '55%'],
                        data: this.jobData,
                        color:['#3272ff','#139b83', '#fe9f0a','#FF8EB4','#32c7ff','#FE5B0A'],
                    }
                ]
            };
            myChart.setOption(option);
        },
        myEcharts2() {
            const myChart = echarts.init(this.$refs.chart2);
            const option = {
            tooltip: {
                trigger: 'item',
                formatter:'{c}%'　　　　//这是关键，在需要的地方加上就行了
            },
            xAxis: {
                    type: 'category',
                    data: this.areaDataX,
                    axisTick: {
                        show: false
                    },
                    axisLine:{
                        lineStyle:{
                            color:'#5e6166',
                            opacity: 0.3,
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle:{
                            color: ['#e2e2e2'],
                            width: 1,
                            type: 'solid'
                        }
        　　        },
                    axisLabel : {
                        formatter: '{value}%',
                        textStyle: {
                            color: '#5e6166'
                        }
                    },
                    axisLine:{
                        lineStyle:{
                            color:'#5e6166',
                            opacity: 0.3,
                        }
                    } 
                    
                },
                series: [{
                    data: this.areaDataY,
                    type: 'bar',
                    barWidth:48,
                    label: {
                        show: true,
                        position: 'top',
                        color: '#3272ff',
                        formatter: '{c}%'
                    },
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                offset: 1,
                                color: "#60aaff"
                            }, {
                                offset: 0,
                                color: "#3272ff"
                            }], false)
                        }
                    },
                }]
            };
            myChart.setOption(option);
        },
        schoolDetailHandler(scl_id) {
            this.$router.push({
				path:'schoolDetail',
                query: {
                    scl_id: scl_id
                }
			})
        },
        getSpecialDetailHandler() {
            getSpecialDetail(this.special_id).then(res => {
                this.searchSchoolStatus1 = true;
                this.majorInfor = res.data;
                let jobData = [];
                let areaDataX = [];
                let areaDataY = [];
                let percent = res.data.special_type_rate==':'? [] : res.data.special_type_rate.split(":");
                this.majorInfor = Object.assign({},this.majorInfor,{percent:percent});
                this.fav_data = res.data.fav_data
				const fav_tmp = this.fav_data.filter(val =>{ return val.fav === 1 })
				this.fav_value = parseFloat((fav_tmp.length / this.fav_data.length).toFixed(2))
				this.fav_value -= 0.01
                if(percent.length != 0) {
                    this.percentData = [
                        {value: Number(percent[0]), name: '文科'},
                        {value: Number(percent[1]), name: '理科'},
                    ];
                } else {
                    this.percentData = [
                        {value: 0, name: '文科'},
                        {value: 0, name: '理科'},
                    ];
                }
                res.data.special_job_post.forEach(element => {
                    let obj = {};
                    obj.value = Number(element.rate);
                    obj.name = element.detail_pos;
                    jobData.push(obj);
                });
                res.data.special_job_location.forEach(element => {
                    areaDataX.push(element.area);
                    areaDataY.push(Number(element.rate));
                });
                this.jobData = jobData;
                this.areaDataX = areaDataX;
                this.areaDataY = areaDataY;
                this.$nextTick(() => {
                    if(percent.length != 0 && percent[0] && percent[1]) {
                        this.myEcharts();
                    }
                    if(jobData.length != 0) {
                        this.myEcharts1();
                    }
                    if(areaDataX.length != 0) {
                        this.myEcharts2();
                    }
                })
            })
        },
        getRelateSchoolhandler(page) {
            getRelateSchool(this.special_id,page).then(res => {
                const data = res.data;
                this.totalData = data.count;
                let schoolList = [];
                    data.data.forEach((item) => {
                    let obj = {};
                    let school_type = '';
                    let school_nature = '';
                    obj = item;
                    if(item.scl_type == '5000') {
                        school_type = '综合'
                    } else  if(item.scl_type == '5001') {
                        school_type = '理工'
                    } else  if(item.scl_type == '5002') {
                        school_type = '农林'
                    } else  if(item.scl_type == '5003') {
                        school_type = '医药'
                    } else  if(item.scl_type == '5004') {
                        school_type = '师范'
                    } else  if(item.scl_type == '5005') {
                        school_type = '语言'
                    } else  if(item.scl_type == '5006') {
                        school_type = '财经'
                    } else  if(item.scl_type == '5007') {
                        school_type = '政法'
                    } else  if(item.scl_type == '5008') {
                        school_type = '体育'
                    } else  if(item.scl_type == '5009') {
                        school_type = '艺术'
                    } else  if(item.scl_type == '5010') {
                        school_type = '民族'
                    } else  if(item.scl_type == '5011') {
                        school_type = '军事'
                    } else {
                        school_type = '其他'
                    }
                    if(item.scl_nature == '36000') {
                        school_nature = '公办'
                    } else if(item.scl_nature == '36001') {
                        school_nature = '民办'
                    } else if(item.scl_nature == '36002') {
                        school_nature = '中外合作办学'
                    }
                    // if (item.scl_nature_type == '6000') {
                    //     if(item.f211 == '1' || item.f985 == '1' || item.is_provincial == '1' || (item.dual_class != '38003' && item.dual_class)) {
                    //         school_nature_type = '本科'
                    //     } else {
                    //         school_nature_type = '普通本科'
                    //     }
                    // } else if (item.scl_nature_type == '6001') {
                    //     if(item.is_doublehigh == '77') {
                    //         school_nature_type = '专科'
                    //     } else {
                    //         school_nature_type = '普通专科'
                    //     }
                    // } else if (item.scl_nature_type == '6002') {
                    //     school_nature_type = '中外合作办学'
                    // }
                    obj.school_type = school_type;
                    obj.school_nature = school_nature;
                    obj.school_nature_type = this.type_edu[item.scl_nature_type];
                    schoolList.push(obj);
                })
                this.schoolList = schoolList;
            })
        },
        // 心仪详情
		favDetail() {
			if(this.fav_data.length <= 1) {
				const data = this.fav_data[0]
				const param = {
					stu_id: data.stu_id,
					fav_type: 2,
					data: this.special_id
				}
				if(data.fav === 0) {
					addFav(param).then(res => {
						data.fav = 1
                        this.updateFav(this.fav_data)
						this.$forceUpdate()
					})
				} else {
					delFav(param).then(res => {
						data.fav = 0
                        this.updateFav(this.fav_data)
						this.$forceUpdate()
					})
				}
				return
			}
			this.fav_info = {
				name: this.majorInfor.special_name,
				id: this.special_id,
				fav_type: 2
			}
			this.$store.commit('user/SHOWISFAV', true)
		},
		// 心仪更新
		updateFav(data) {
			this.fav_data = [...data]
			const fav_tmp = this.fav_data.filter(val =>{ return val.fav === 1 })
			this.fav_value = parseFloat((fav_tmp.length / this.fav_data.length).toFixed(2))
			this.fav_value -= 0.01
		}
    },
}
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
	.major-detail-bg {
		@include gwidth;
		height: 207px;
		background: url('../../assets/images/majorDetail.jpg') no-repeat;
		background-size: 100% 100%;
		margin-top: 24px;
		padding: 32px 40px 0 40px;
	}
    .zytb-school-name {
		font-size: 32px;
		font-weight: 600;
		color: #fff;
		margin-bottom: 14px;
	}
	.zytb-school-tag span {
		display: inline-block;
		padding: 3px 10px;
		font-size: 12px;
		color: #ffffff;
		height: 22px;
		background: rgba(255,255,255,0.20);
		border-radius: 4px;
		line-height: 22px;
		margin-right: 8px;
		margin-top: 10px;
	}
    .school-detail-nav {
		@include gwidth;
        margin-top: -46px;
	}
    .school-detail-common {
		background: #ffffff;
		border-radius: 10px;
		box-shadow: 0px 1px 2px 0px rgba(44,46,51,0.10);
		padding: 24px;
		margin-bottom: 16px;
        position: relative;
		h3 {
			font-size: 20px;
			font-weight: 600;
			color: #2c2e33;
			border-left: 3px solid $common-color;
			padding-left: 8px;
			margin-top: 0;
            margin-bottom: 24px;
		}
        p {
            font-size: 16px;
            color: #5e6166!important;
            margin-top: 5px;
            margin-bottom: 0;
            line-height: 24px;
        }
        p:not(:last-child) {
            margin-bottom: 12px;
        }
        .special-content-p {
            color: #2c2e33!important;
            ::v-deep p {
                margin-top: 5px;
                margin-bottom: 0;
                line-height: 24px;
                font-size: 400;
            }
            ::v-deep p:not(:last-child) {
                margin-bottom: 26px;
            }
        }
        .special-content-p-diff {
            max-height: 310px;
            overflow: hidden;
        }
        .special-content-p-more {
            max-height: 10000px;
        }
        .choice-box {
            font-size: 14px;
            margin-top: 10px;
            color: $common-color;
            cursor: pointer;
            float: right;
            i {
                margin-left: 5px;
            }
        }
	}
    .major-detail-js {
        text-align: center;
        width: 60px;
        height: 24px;
        line-height: 24px;
        border-radius: 4px;
        font-weight: 600;
        font-size: 16px;
        color: #ffffff;
    }
    .major-detail-js:not(:first-child) {
        margin-top: 24px;
    }
    .major-detail-blue {
        background: $common-color;
    }
    .major-detail-green {
        background: #139b83;
    }
    .major-detail-hs {
        background: #fe9f0a;
    }
    .school-detail-jy {
        color: $common-color;
        font-size: 24px;
        font-weight: 600;
    }
    .school-detail-jyl {
        font-size: 24px;
        font-weight: 600;
        color: $common-color;
        span {
            display: inline-block;
            font-size: 16px;
            font-weight: 600;
            position: relative;
            left: 16px;
            top: -4px;
            width: 90px;
        }
    }
    .major-detail-sex {
        .school-detail-common {
            box-sizing: border-box;
            h3 {
                margin-bottom: 24px;
            }
        }
        .el-col-12:first-child {
            padding-right: 16px;
        }
        .el-col-4 {
            text-align: center;
        }
        .el-col-16 {
            position: relative;
        }
        img {
            width: 70px;
            height: 70px;
            margin-bottom: 5px;
        }
        .major-detail-bl {
            width: 164px;
            height: 8px;
            background: #ff8eb4;
            border-radius: 8px;
            margin-left: 16px;
        }
        .major-detail-xb {
            margin-top: 28px;
            padding: 0 14px 10px 14px;
            font-size: 18px;
        }
        .major-detail-girl {
            float: right;
            color: #ff8eb4;
        }
        .major-detail-boy {
            color: #3272ff;
        }
        .major-detail-bl-boy {
			height: 8px;/* 宽高 */
			background-color: #3272ff;/* 颜色 */
			border-radius: 8px;/* 设置圆角 */
			transform: perspective(8px) rotateX(-2deg);
			transform-origin: bottom left;
            position: absolute;
            bottom: 30px;
            left: 86px;
        }
    }
    .school-detail-wl {
        // .el-col-16 {
        //     position: absolute;
        // }
        // .el-col-4 {
        //     margin-left: 60%;
        //     margin-top: -10px;
        // }
        h3 {
            margin-bottom: 50px!important;
        }
        .school-detail-wl-rate {
            margin-top: 170px;
        }
        .school-detail-wl-rate div {
            width: 100%;
            height: 40px;
            line-height: 40px;
            background: #f0f2f5;
            border-radius: 4px;
            margin-bottom: 14px;
            text-align: left;
            padding: 0 16px;
            box-sizing: border-box;
            font-size: 14px;
            color: #5e6166;
            span {
                font-weight: 600;
                font-size: 20px;
                margin-left: 10px;
            }
        }
    }
    .school-detail-jyfb {
        .el-progress-blue {
            color: #909399;
            font-weight: 600;
        }
        .school-detail-qt {
            color: #2c2e33;
            font-weight: 400;
            padding: 0 16px 0 0;
            text-align: right;
            width: 106px;
            font-size: 18px;
            left: 0;
        }
    }
    .major-detail-common h3 {
        margin-bottom: 39px;
    }
    .school-detail-jyfb:not(:last-child) {
        margin-bottom: 24px;
    }
    .major-detail-gwfb:not(:last-child) {
        margin-bottom: 16px;
    }
    .major-detail-gwfb {
        padding: 16px 20px;
        background: #f5f7fa;
        border-radius: 5px;
        color: #2c2e33;
        font-size: 14px;
        margin-bottom: 16px;
        width: 88%;
        line-height: 18px;
        p {
            color: #909399;
            font-size: 14px;
            margin: 0;
            margin-bottom: 6px;
            line-height: 16px;
        }
    }
    .major-detail-gwfb-qt {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 6px;
    }
    .major-detail-gwfb-blue,.major-detail-gwfb-0 {
        color: #3272ff;
    }
    .major-detail-gwfb-green,.major-detail-gwfb-1 {
        color: #139b83;
    }
    .major-detail-gwfb-hs,.major-detail-gwfb-2 {
        color: #fe9f0a;
    }
    .major-detail-gwfb-3 {
        color: #FF8EB4;
    }
    .major-detail-gwfb-4 {
        color: #32c7ff;
    }
    .major-detail-gwfb-5 {
        color: #FE5B0A;
    }
    .school-detail-gwfb-diff1 {
        height: 355px;
    }
    .collapse-box {
		width: 100%;
        border-top: 1px solid #f0f2f5;
        margin-top: 24px;
		font-size: 0;
		img,.el-image {
			width: 64px;
			height: 64px;
		}
		.el-col-3 {
			width: 7.5%;
		}
        .el-col-4 {
            float: right;
        }
        .zytb-school-name {
            font-size: 18px;
            font-weight: 600;
            color: #2c2e33;
            margin-bottom: 5px;
        }
        .zytb-school-tag span {
            display: inline-block;
            padding: 3px 8px;
            font-size: 12px;
            color: #909399;
            height: 22px;
            background: #f0f2f5;
            border-radius: 4px;
            line-height: 22px;
            margin-right: 4px;
        }
        .zytb-school-major {
            color: $common-color;
            font-size: 14px;
            margin-top: 20px;
            position: relative;
            right: -6px;
        }
        .zytb-school-name img {
            width: 16px;
            height: 16px;
            position: relative;
            top: 2px;
            left: 5px;
            margin-left: 5px;
        }
        .zytb-school-name span {
            color: #909399;
            font-size: 12px;
            font-weight: 400;
            position: relative;
            top: -2px;
            left: 5px;
        }
        .zytb-school-tag {
            margin-top: -3px;
        }
        button {
            width: 100px;
            height: 30px;
            border: 1px solid $common-color;
            border-radius: 5px;
            color: $common-color!important;
            font-size: 14px;
            text-align: center;
            line-height: 30px;
            padding: 0;
            margin-top: 15px;
			background-color: #fff;
        }
        .el-col-4 {
            text-align: right;
        }
        button:hover {
            background-color: #fff;
        }
        .con-line {
            width: calc(100% - 82px);
            height: 1px;
            background: #f0f2f5;
            position: absolute;
            right: 0;
            bottom: 0;
        }
    }
    .collapse-list {
        height: 104px;
        padding: 20px 0;
        position: relative;
        box-sizing: border-box;
    }
    .no-data-box {
        position: relative;
        top: 70px;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        img {
            width: 110px;
            height: 110px;
        }
        p {
            font-size: 16px;
            text-align: center;
            color: #abaeb3;
            margin-left: -14px;
        }
    }
    .compare-view,.compare-view-diff {
		width: 136px;
		height: 50px;
		background: rgba(255,255,255,0.20)!important;
		border: 1px solid #ffffff;
		border-radius: 8px;
		color: #ffffff;
		font-size: 18px;
		text-align: center;
		padding: 0;
		margin-top: 34px;
		background-color: #fff;
		float: right;
		margin-left: 16px;
		img {
			width: 12px;
			height: 12px;
		}
		.fav-img1 {
			width: 18px;
			height: 18px;
			position: relative;
			top: 2px;
		}
	}
	.compare-view-diff {
		color: $common-color!important;
		background: #ffffff!important;
		border: none!important;
	}
    ::v-deep {
		.el-rate__icon {
			font-size: 24px;
			position: relative;
			top: -2px;
			margin-right: 2px;
		}
		.el-rate__decimal {
			color: #ff6524!important;
			font-size: 24px;
		}
		.compare-view-diff span {
			display: flex;
			align-items: center;
			justify-content: center;
		}
	} 
</style>